import React, {Component} from 'react';
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import {Button, Col, Form, Input, Modal, Row, Upload} from "antd";
import {UploadDocEngineStates} from "./types/UploadDocEngineTypes";
import {SaveOutlined, UploadOutlined} from "@ant-design/icons";
import {docUploadApiService} from "../../services/otodis/DocUploadApiService";

export interface UploadDocEngineProps {
}

class UploadDocEngine extends Component<UploadDocEngineProps & any, UploadDocEngineStates> {
    private readonly initState!: UploadDocEngineStates;

    constructor(props: UploadDocEngineProps & any | any) {
        super(props);

        this.initState = {
            engineNumber: "",
            submitting: false,
            showUploadList: false,
            inputImage: [],
            validImage: false,
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
        }
        this.state = {...this.initState}
    }

    onDealerChange = async (data: any) => {
        this.setState({
            dealerCode: data.value,
        });
    }

    onFieldChange = <T extends keyof Pick<{ engineNumber: string }, "engineNumber">>(target: T, value: string) => {
        const currentState: any = {...this.state};
        switch (target) {
            case "engineNumber":
                currentState.engineNumber = value;
                break;
        }
        this.setState({
            ...currentState,
        });
    }

    beforeUploadFile = (file: any) => {
        this.setState({
            showUploadList: true
        });

        const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
        if (!isJpgOrPng) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'Format File Bukan JPG/PNG'
            });
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'File Size harus kurang dari 2MB'
            });
        }
        if (isJpgOrPng && isLt2M) {
            this.setState({
                inputImage: file,
                validImage: true,
            });
        } else {
            this.setState({
                validImage: false,
            });
        }
        return false;
    };

    submitData = async () => {

        if (!this.state.validImage || !this.state.engineNumber) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'Data tidak lengkap'
            });
            return false;
        }

        this.setState({
            submitting: true,
        });

        const formData = new FormData();
        formData.append("vehicle_engine_number", this.state.engineNumber);
        formData.append("document_image", this.state.inputImage);

        try {
            await docUploadApiService.uploadDocEngine(formData);
            Modal.success({
                title: 'Proses Sukses',
                content: 'Data berhasil ditambah'
            });
            this.setState({
                inputImage: [],
                validImage: false,
                submitting: false,
                showUploadList: false,
                engineNumber: "",
            });
        } catch (e: any) {
            this.setState({
                submitting: false,
            });
            Modal.error({
                title: 'Proses Gagal',
                content: 'Server Menolak Inputan Anda :' + e.message
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                <MainLayout onChangeDealer={this.onDealerChange} breadcrumbPath={`Dokumen`} breadcrumbMenu={`Upload Doc Engine`} defaultSelectedKeys={['m-upload-doc-engine']} defaultOpenKeys={['sm-document']}>
                    <Row>
                        <Col span={16} push={4}>
                            <Form layout="vertical">
                                <Form.Item label="Nomor Mesin">
                                    <Input value={this.state.engineNumber} onChange={event => this.onFieldChange("engineNumber", event.target.value)} placeholder="Masukan Nomor Mesin"/> <br/>
                                </Form.Item>

                                <Form.Item label="Gambar Dokumen">
                                    <Upload
                                        maxCount={1}
                                        listType="picture"
                                        beforeUpload={this.beforeUploadFile}
                                        showUploadList={this.state.showUploadList}
                                    >
                                        <Button
                                            icon={<UploadOutlined/>}
                                        >
                                            Select File
                                        </Button>
                                    </Upload>
                                </Form.Item><br/>

                                <Form.Item>
                                    <Button type="primary" loading={this.state.submitting} onClick={event => this.submitData()} icon={<SaveOutlined/>}>Simpan</Button>
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(UploadDocEngine), 15));
